import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLinkWithHref } from '@angular/router';
import { SharedModule } from 'primeng/api';

@Component({
  selector: 'ra-support-service',
  standalone: true,
  imports: [CommonModule, RouterLinkWithHref, SharedModule],
  templateUrl: './support-service.component.html',
  styleUrls: ['./support-service.component.scss'],
})
export class SupportServiceComponent {
  @Output() openFeedbackModal = new EventEmitter<number>();
  @Input() isDemo!: boolean;

  menuState = false;

  @HostListener('mouseenter') onMouseEnter() {
    this.menuState = true;
  }
  @HostListener('mouseleave') onMouseLeave() {
    this.menuState = false;
  }
}
